import React, { memo } from 'react'
import {
  Alert,
  AlertTitle,
  Box,
  Grid2,
  Stack,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { faCardsBlank, faCoinFront } from '@fortawesome/pro-duotone-svg-icons'

import Popup from '../shared/popup/Popup'
import Text from '../shared/text/Text'
import { Image } from '../shared/image'
import { formatCurrencyShort } from '../../util/number.helpers'
import AnimateRewards from '../shared/animateRewards/AnimateRewards'
import FaIcon from 'src/components/shared/faIcon/FaIcon'
import { SCRATCH_CARD_VALUE } from '../../constants/game'

const ConfirmationPopup = ({ onSubmit, onCancel, t, value, symbol, gif }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <Popup
      onCancel={onCancel}
      cancelLabel={t('common.close')}
      onFormSubmit={onSubmit}
      submitLabel={
        isMobile
          ? t('game.scratch-again')
          : t('game.scratch-another', {
              value: SCRATCH_CARD_VALUE,
              symbol
            })
      }
      submitBtnProps={{
        endIcon: <FaIcon icon={faCardsBlank} />
      }}
    >
      <Grid2 container spacing={{ xs: 2, md: 3 }}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Image src={gif} sx={{ borderRadius: 1.5, width: '100%' }} />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Box sx={{ height: 1, display: 'flex', flexDirection: 'column' }}>
            <Text
              color='inherit'
              variant='h6'
              label={t(
                `game.${value > 0 ? 'you-won' : 'better-luck-next-time'}`
              )}
            />
            <Stack spacing={0.5} sx={{ py: { xs: 1, md: 1 } }}>
              <Alert
                severity='primary'
                sx={{ mt: 0.5, py: 0, px: 1 }}
                icon={<FaIcon icon={faCoinFront} />}
              >
                <AlertTitle>{t('game.your-prize')}</AlertTitle>
                <Text
                  label={`${formatCurrencyShort(value)} ${symbol}`}
                  sx={{ fontSize: '1.5rem', fontWeight: 700 }}
                />
              </Alert>
              <Text
                label={t(
                  `game.${value > 0 ? 'think-you-can-win' : 'you-can-always-try'}`
                )}
                sx={{ mt: 1 }}
              />
            </Stack>
          </Box>
        </Grid2>
      </Grid2>
      {value && <AnimateRewards />}
    </Popup>
  )
}

export default memo(ConfirmationPopup)
